var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#B2F6D6",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4617 15.5874H15.5867C14.7169 15.5874 14.0117 16.2926 14.0117 17.1624V21.8874C14.0117 22.7573 14.7169 23.4624 15.5867 23.4624H23.4617C24.3316 23.4624 25.0367 22.7573 25.0367 21.8874V17.1624C25.0367 16.2926 24.3316 15.5874 23.4617 15.5874Z",
    stroke: "#00A759",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5242 21.1002C20.3941 21.1002 21.0992 20.395 21.0992 19.5252C21.0992 18.6553 20.3941 17.9502 19.5242 17.9502C18.6544 17.9502 17.9492 18.6553 17.9492 19.5252C17.9492 20.395 18.6544 21.1002 19.5242 21.1002Z",
    stroke: "#00A759",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8883 15.5875V14.0125C21.8883 13.5948 21.7223 13.1942 21.427 12.8988C21.1316 12.6034 20.731 12.4375 20.3133 12.4375H12.4383C12.0206 12.4375 11.62 12.6034 11.3246 12.8988C11.0292 13.1942 10.8633 13.5948 10.8633 14.0125V18.7375C10.8633 19.1552 11.0292 19.5558 11.3246 19.8512C11.62 20.1466 12.0206 20.3125 12.4383 20.3125H14.0133",
    stroke: "#00A759",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSales);
export default __webpack_public_path__ + "static/media/total_sales.55c62c407ab1e130f5e95e0d5e029435.svg";
export { ForwardRef as ReactComponent };